import { render, staticRenderFns } from "./HeaderCom.vue?vue&type=template&id=619d86ba&scoped=true"
import script from "./HeaderCom.vue?vue&type=script&lang=js"
export * from "./HeaderCom.vue?vue&type=script&lang=js"
import style0 from "./HeaderCom.vue?vue&type=style&index=0&id=619d86ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619d86ba",
  null
  
)

export default component.exports